export default __webpack_public_path__ + "static/media/author.2d8e977c.jpg";